export default __webpack_public_path__ + "ca7d6c82bc63388ba9807786a3fe046c.svg";